import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiService, DataService, InspectionPluginService } from '../../../shared/services/index';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';
import { InstallationCustomerContactPluginFactoryService } from './customer-contact-plugin-factory.plugin';
import { of } from 'rxjs';

@Injectable()
export class InstallationCustomerContactPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private customerContactFactory: InstallationCustomerContactPluginFactoryService
  ) {
    super(apiService, dataService, null);
  }

  public updateCustomerContact(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    customerContacts: any[]
  ): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, customerContacts).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, customerContacts: any[]): Observable<any> {
    return this.customerContactFactory
      .updateCustomerContact(inspectionId, pointId, pluginId, customerContacts, 'CustomerContacts')
      .pipe(
        flatMap((plugin) => {
          if (this.isInspectionInOffline(inspectionId)) {
            return of(plugin);
          }
          return this.apiService.post(plugin.postServerUrl, plugin.config);
        })
      );
  }
}
